module.exports = __webpack_public_path__ + "img/35-MobileTPV.d3c26ecb.jpg";